import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Button } from "../../Common";
import styles from "./Customer.module.css";
import { updateCustomer } from "../../api";
import CommentModal from "../../Common/CommentModal/commentModal";
import Input from "../../Common/V2/Widgets/Input";

const BasicDetail = ({ data, isEditable, refreshDetails, listStatus}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [firstName, setFirstName] = useState(data?.firstName || "");
  const [lastName, setLastName] = useState(data?.lastName || "");
  const [middleName, setMiddleName] = useState(data?.middleName || "");
  const [email, setEmail] = useState(data.email);
  const [phone, setPhone] = useState(data.phno);
  const [accountStatus, setAccountStatus] = useState(data.accountStatus);
  const [accountcreatedAt, setAccountcreatedAt] = useState(
    data.accountcreatedAt
  );
  const [successMessage, setSuccessMessage] = useState("");

  const [partnerCode, setPartnerCode] = useState(data.partnerCode);
  const [customerId, setCustomerId] = useState(data.customerId);

  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isComment, setIsComment] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");

  const updateCustomerDetail = async (custId) => {
    if (loading) return;
    setLoading(true); 
    const data = {
      comment: isComment,
      email: email,
      phone: phone,
      firstName: firstName,
      lastName: lastName,
      middleName: middleName,
    };
  try {
    const resp = await updateCustomer(custId, data);
    if (resp?.code === 200) {
      setIsEdit(false);
      setSuccessMessage(resp?.data || "Details updated successfully!");
      await refreshDetails();
      setErrorMessage("");
      setTimeout(() => {
        setSuccessMessage("");
        setIsModalOpen(false);
      }, 5000);
    } else {
      setSuccessMessage("");
      setError("");
      setComment("");
      setErrorMessage(resp?.data?.message || "Something went wrong");
      setTimeout(() => {
        setIsModalOpen(false);
      }, 3000);
    }
  } catch (error) {
    setSuccessMessage("");
    setError("");
    setComment("");
    setErrorMessage(
      error?.response?.data?.message || "Failed to update details"
    );
    setTimeout(() => {
      setIsModalOpen(false);
    }, 3000);
  } finally {
    setLoading(false);
  }
};

  const initialData = {
    firstName: data?.firstName || "",
    lastName: data?.lastName || "",
    middleName: data?.middleName || "",
    email: data.email,
    phone: data.phno,
  };

  const handleBackButton = () => {
    setFirstName(initialData.firstName);
    setLastName(initialData.lastName);
    setMiddleName(initialData.middleName);
    setEmail(initialData.email);
    setPhone(initialData.phone);

    setIsEdit(false);
  };

  const handleSavebutton = async () => {
    setIsModalOpen(true);
    setErrorMessage("");
    setError("");
    setSuccessMessage("");
    setComment("");
  };

  const handleToggleModal = () => {
    setIsModalOpen(false);
  };

  const date = new Date(accountcreatedAt);

  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");

  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");

  const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;


  return (
    <div style={{ marginTop: "30px" }}>
      <Row className={styles.detailContainer}>
        <Col className="p-0">Basic Detail</Col>
        {isEditable && listStatus !== "CLOSED" && data?.accountStatus !== "CLOSED" ? (
          <Col
            md={2}
            onClick={() => setIsEdit(true)}
            style={{
              cursor: "pointer",
              display: "flex",
              justifyContent: "end",
            }}
          >
            <div style={{ width: "max-content" }}>
              {isEdit ? (
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <Button
                    title="Save"
                    margin={"0px 10px"}
                    disabled={loading}
                    onClick={handleSavebutton}
                  />

                  <Button
                    title="Back"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleBackButton();
                    }}
                  />
                </div>
              ) : (
                "Edit"
              )}
            </div>
          </Col>
        ) : (
          ""
        )}
      </Row>
      {isEdit ? (
        <>
          <Row style={{ marginTop: 10 }}>
            <Col className={styles.text}>
              <Input
                label="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </Col>
            <Col className={styles.text}>
              <Input
                label="Middle Name"
                value={middleName}
                onChange={(e) => setMiddleName(e.target.value)}
              />
            </Col>
            <Col className={styles.text}>
              <Input
                label="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
          <Col className={styles.text}>
              <Input
                label="Customer Id"
                value={customerId}
                onChange={(e) => setCustomerId(e.target.value)}
                disabled
              />
            </Col>
            <Col className={styles.text}>
              <Input
                label="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Col>
            <Col className={styles.text}>
              <Input
                label="Phone Number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col className={styles.text}>
              <Input
                label="Account Status"
                value={accountStatus || "--"}
                onChange={(e) => setAccountStatus(e.target.value)}
                disabled
              />
            </Col>
            <Col className={styles.text}>
              <Input
                label="Account Created At"
                value={accountcreatedAt}
                onChange={(e) => setAccountcreatedAt(e.target.value)}
                disabled
              />
            </Col>
            <Col className={styles.text}>
              <Input
                label="Partner Code"
                value={partnerCode}
                onChange={(e) => setPartnerCode(e.target.value)}
                disabled
              />
            </Col>
          </Row>
         
        </>
      ) : (
        <>
          <Row style={{ marginTop: 10 }}>
            <Col className={styles.text}>First Name : {firstName || "--"}</Col>
            <Col className={styles.text}>
              Middle Name : {middleName || "--"}
            </Col>
            <Col className={styles.text}>Last Name : {lastName || "--"}</Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col className={styles.text}>Email : {email || "--"}</Col>
            <Col className={styles.text}>Phone Number : {phone || "--"}</Col>
            <Col className={styles.text}>
              Account Status : {accountStatus || "--"}
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            
            <Col className={styles.text}>
              Account Opening Date : {accountcreatedAt || "--"}
            </Col>
            <Col className={styles.text}>
              Partner Code : {partnerCode || "--"}
            </Col>
            <Col className={styles.text}>
              Customer Id : {customerId || "--"}
            </Col>
          </Row>
        </>
      )}
      <CommentModal
        setIsComment={setIsComment}
        isOpen={isModalOpen}
        onRequestClose={handleToggleModal}
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
        errorMessage={errorMessage}
        error={error}
        setError={setError}
        comment={comment}
        setComment={setComment}
        onSave={() => updateCustomerDetail(data.customerId)}
        loading={loading}
      />
    </div>
  );
};

export default BasicDetail;